export const JSON_ONE1 = {
   
  
    "header": {
    "ipAddress": "192.168.1.137",
    "userAgent": "Java/1.8.0_73",
    "operatingSystem": "andriod",
    "sessionId": "AGGR002557",
    "version": "1.0.0",
    "key": "Vcuefev63852032923nducwg8ye8",
    "date": "Dec 26, 2018 6:45:15 PM",
    "requestId": "2c699c94-c70d-42d2-b7b3-b28e37defe12"
    },
    "transaction": {
    "requestType": "ONBO",
    "requestSubType": "“CHECK”",
    "channel": "WEB",
    "agId": "AGGR002557",
    "tranCode": "76",
    "txnAmt": "0.0"
    },
    "userInfo": { },
    "response": {
    "code": "O",
    "description": "App version Match"
    }
    }

export const JSON_TWO2 = {
    
  
    "header": {
    "ipAddress": "192.168.1.147|192.168.1.147",
    "userAgent": "Mozilla/5.0Chrome/75.0.3770.142 Safari/537.36",
    "operatingSystem": "WEB",
    "sessionId": "9e819fb4a7c6d6453b32489d98",
    "version": "1.0.0",
    "date": "Mar 11, 2020 12:37:01 PM",
    "requestId": "3e98421c-db2a-4107-bc65-09ffe817aae2"
    },
    "transaction": {
    "requestType": "WTW",
    "requestSubType": "LMREQ",
    "agId": "AGGR001158",
    "uId": "AGGR001158"
    },
    "response": {
    "code": "0000",
    "description": "Successful"
    },
    "loadMoneyModel": {
    "aggregatorId": "AGGR001158",
    "txnAmount": "5000.0",
    "status": "Success",
    "createdBy": "AGGR001158",
    "ipAddress": "192.168.1.147",
    "userAgent": "Mozilla/5.o Chrome/80.0.3987.132 Safari/537.36",
    "responseCode": "S0005",
    "responseMsg": "Money has been loaded successfully AMIW001010",
    "mobileNo": "9926355663",
    "userId": "AGGR001158"
    }
    }

export const JSON_THREE3 = {
    
  
    "header": {
    "ipAddress": "192.168.1.147|192.168.1.147",
    "userAgent": "Mozilla/5.0Chrome/75.0.3770.142 Safari/537.36",
    "operatingSystem": "WEB",
    "sessionId": "21a230ad05d12a95f88",
    "version": "1.0.0",
    "date": "Mar 11, 2020 12:37:01 PM",
    "requestId": "94ac3035-3aad-4658-9824-0a0286788bfd"
    },
    "transaction": {
    "requestType": "WTW",
    "requestSubType": "LMSL",
    "userId": "AGGR001158",
    "id": "AGGR001158",
    "uId": "AGGR001158"
    },
    "response": {
    "code": "0000",
    "description": "Successful"
    },
    "loadMoneyModel": {
    "usertype": "4.0"
    },
    "loadMoneyReqList": [
    {}
    ]
    }

export const JSON_FOUR4 = {
    

  
    "header": {
    "ipAddress": "192.168.1.147",
    "userAgent": "Mozilla/5.0 Chrome/75.0.3770.142 Safari/537.36",
    "operatingSystem": "WEB",
    "sessionId": "639834816cbd070b82cab554b95c4bab",
    "version": "1.0.0",
    "date": "Mar 17, 2020 8:35:45 PM",
    "requestId": "66f71ab0-7607-4e22-9cf4-d7f7b5906978"
    },
    "transaction": {
    "requestType": "WTW",
    "requestSubType": "BENEF",
    "userId": "AGGR001158",
    "id": "AGGR001158",
    "uId": "AGGR001158"
    },
    "beneList": [
    {}
    ]
    }


export const JSON_FIVE5 = {
 
  
    "header": {
    "ipAddress": "192.168.1.147",
    "operatingSystem": "andriod"
    },
    "transaction": {
    "requestType": "WTW",
    "requestSubType": "PWTB",
    "agId": "AGGR001001",
    "transCode": "267",
    "transAmt": "0.0",
    "otp": "088446",
    "otp_ref_number": "oWPYHZxmiLXRIDEoVvHL",
    "uId": "CUST001296"
    },
    "response": {
    "code": "S0026",
    "description": "Wallet To Bank Amount Transfer Successfully, Ref No :PAYO001101"
    },
    "payOutBean": {
    "payoutId": "PAYO001101",
    "mobileNo": "917985858585",
    "customerId": "CUST001296",
    "txnAmount": "2.00",
    "accountNo": "3*********9",
    "ifscCode": "K*********2",
    "bankName": "kotak",
    "accountHolderName": "ABCD",
    "txnType": "IMPS",
    "aggregatorId": "IMPS",
    "accountType": "Saving",
    "txnStatus": "success",
    "bankRefNo": "900119955393",
    "spkRefNo": "00417",
    "bankStatus": "SUCCESS",
    "statusCode": "00000",
    "statusDesc": "Success",
    "txnDate": "Wed Nov 27 16:30:42 IST 2019"
    }
    }


export const JSON_SIX6 = {
    
  
    "header": {
    "ipAddress": "0.0.0.0|192.168.1.150",
    "userAgent": "Java/1.8.0_73",
    "operatingSystem": "WEB",
    "sessionId": "b0f3084dca2fd410e21b50a5c30dbeef9a8410814354ab99c4e04766ca0f6a02",
    "date": "Jun 19, 2020 7:45:47 PM",
    "requestId": "e2b2be5d-d106-41d6-94d2-ee78e085bb11"
    },
    "transaction": {
    "requestType": "TMH",
    "requestSubType": "WTAL",
    "agId": "AGGR001158",
    "transCode": "268",
    "txnAmt": "0.0",
    "userId": "CUST001296"
    },
    "response": {
    "code": "0000",
    "description": "Successful"
    },
    "payOutBean": {
    "customerId": "AGGR001158",
    "StartDate": "2020-03-01",
    "EndDate": "2020-03-18"
    },
    "payOutList": [
    {}
    ]
    }




export const JSON_SEVEN7 = {
    
  
    "header": {
    "ipAddress": "0.0.0.0|192.168.1.150",
    "userAgent": "Java/1.8.0_73",
    "operatingSystem": "WEB",
    "sessionId": "b0f3084dca2fd410e21b50a5c30dbeef9a8410814354ab99c4e04766ca0f6a02",
    "date": "Jun 19, 2020 7:58:07 PM",
    "requestId": "5bcec97b-82b0-4b93-82aa-0cf05e2d125e"
    },
    "userInfo": { },
    "transaction": {
    "requestType": "TMH",
    "requestSubType": "WTAL",
    "channel": "WEB",
    "agId": "AGGR001158",
    "transCode": "268",
    "txnAmt": "0.0",
    "userId": "AGGR001158"
    },
    "response": {
    "code": "0000",
    "description": "Successful"
    },
    "payOutBean": {
    "customerId": "AGGR001158"
    },
    "payOutList": [
    {}
    ]
    }


export const JSON_EIGHT8 = {

  
    "header": {
    "ipAddress": "0.0.0.0|192.168.1.150",
    "userAgent": "Java/1.8.0_73",
    "operatingSystem": "WEB",
    "sessionId": "b0f3084dca2fd410e21b50a5c30dbeef9a8410814354ab99c4e04766ca0f6a02",
    "date": "Jun 20, 2020 9:01:56 AM",
    "requestId": "ae9f7490-e9a8-4b67-81c1-baa9a57aca87"
    },
    "userInfo": { },
    "transaction": {
    "requestType": "TMH",
    "requestSubType": "WTAL",
    "channel": "WEB",
    "agId": "AGGR001158",
    "transCode": "268",
    "txnAmt": "0.0",
    "userId": "AGGR001158"
    },
    "payOutBean": {
    "customerId": "AGGR001158",
    "orderRefNo": "7974845996"
    },
    "payOutList": [
    {}
    ]
    }





export const JSON_TEN10 = {

  
    "header": {
    "ipAddress": "192.168.1.147",
    "userAgent": "Java/1.8.0_73",
    "operatingSystem": "andriod",
    "sessionId": "AGGR001158",
    "version": "1.0.0"
    },
    "transaction": {
    "requestType": "WTW",
    "requestSubType": "GPWB",
    "agId": "AGGR001158",
    "id": "AGGR001158"
    },
    "response": {
    "code": "0000",
    "description": "Successful"
    },
    "preLoadingWallet": {
    "walletType": "PAYOUT",
    "finalBal": "2088.0"
    }
    }

    export const JSON_ELEVEN11 = {

      
        "header": {
        "ipAddress": "192.168.1.147",
        "userAgent": "Java/1.8.0_73",
        "operatingSystem": "andriod",
        "sessionId": "AGGR001158",
        "version": "1.0.0"
        },
        "transaction": {
        "requestType": "WTW",
        "requestSubType": "GPWB",
        "agId": "AGGR001158",
        "id": "AGGR001158"
        },
        "response": {
        "code": "0000",
        "description": "Successful"
        },
        "preLoadingWallet": {
        "finalBal": "96874.0"
        }
        }